import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

import MultiSelectDropdown from "./TableFilterCell.components";

import {
  updateFilters,
  getSelectList,
  updateMultipleFilters,
  updateMinMaxFilters,
} from "./TableFilterscells.functions";

TableFilterCell.propTypes = {
  cell: PropTypes.object,
};

export function TableFilterCell(props) {
  const { cell } = props;
  const { type } = cell;

  if (type === "NUMBER") {
    return <NumberFilter {...props} />;
  }
  if (type === "DESCRIPTION") {
    return <DescriptionFilter {...props} />;
  }
  if (type === "STATUS") {
    return <TextAndStatusFilter {...props} />;
  }
  if (type === "CURRENCY") {
    return <CurrencyAndQuantityFilter {...props} />;
  }
  if (type === "QUANTITY") {
    return <CurrencyAndQuantityFilter {...props} />;
  }
  if (type === "PERCENT") {
    return <PercentFilter {...props} />;
  }
  if (type === "DATE") {
    return <DateFilter {...props} />;
  }
  if (type === "TEXT") {
    return <TextAndStatusFilter {...props} />;
  }
  if (type === "CHECK") {
    return <CheckAllCheckBox {...props} />;
  }
  if (type === "IMAGE") {
    return <TextAndStatusFilter {...props} />;
  }
  if (type === "REASONS") {
    return <TextAndStatusFilter {...props} />;
  }
  if (type === "COMMENTS") {
    return <TextAndStatusFilter {...props} />;
  }
  if (type === "LINK") {
    return <TextAndStatusFilter {...props} />;
  }
  if (type === "CRITICAL") {
    return <TextAndStatusFilter {...props} />;
  }
}

DescriptionFilter.propTypes = {
  cell: PropTypes.object,
  data: PropTypes.object,
  width: PropTypes.number,
};

function DescriptionFilter(props) {
  const { cell } = props;
  const { data } = props;
  const { width } = props;

  return (
    <div className="pct-heading-description" style={{ width: width }}>
      {cell.isFiltered && (
        <input
          id="pct-filter-cell-description"
          className="pct-filter-cell-description"
          placeholder="Search"
          onChange={(e) => {
            updateFilters(cell.key, e.target.value, data);
          }}
        />
      )}
    </div>
  );
}

NumberFilter.propTypes = {
  cell: PropTypes.object,
  data: PropTypes.object,
  width: PropTypes.number,
};

function NumberFilter(props) {
  const { cell } = props;
  const { data } = props;
  const { width } = props;

  return (
    <div className="pct-heading-number" style={{ width: width }}>
      {cell.isFiltered && (
        <input
          id="pct-filter-cell-number"
          className="pct-filter-cell-number"
          placeholder="Search"
          onChange={(e) => {
            updateFilters(cell.key, e.target.value, data);
          }}
        />
      )}
    </div>
  );
}

CheckAllCheckBox.propTypes = {
  cell: PropTypes.any,
  width: PropTypes.any,
  checked: PropTypes.any,
  setChecked: PropTypes.any,
  filteredData: PropTypes.any,
  isCheckAllAvailable: PropTypes.any,
};

function CheckAllCheckBox(props) {
  const { cell } = props;
  const { width } = cell;

  // Data for Check All
  const { checked, setChecked } = props;
  const { filteredData } = props;
  const { isCheckAllAvailable } = props;

  const [allChecked, setAllChecked] = useState(false);

  useEffect(() => {
    if (
      // Only show "all ticked" if each item in the visible filtered data is actually ticked
      filteredData.length === checked.length &&
      // Check if ALL filteredData items are checked
      filteredData.every((p) => checked.some((o) => o.id === p.id))
    ) {
      setAllChecked(true);
    } else {
      setAllChecked(false);
    }
  }, [filteredData, checked]);

  if (isCheckAllAvailable) {
    return (
      <div className="pct-checkmark" style={{ width: width }}>
        <input
          id="pct-check-all"
          className="pct-checkmark"
          type="checkbox"
          checked={allChecked}
          onChange={(e) => {
            const isChecked = e.target.checked;

            // If checking this option
            if (isChecked) {
              // Since ALL are being checked we can just set the checked to equal filteredData
              setChecked(filteredData);
            }

            // If unchecking the option
            if (!isChecked) {
              // Since we are unchecking ALL data we can just empty the array
              setChecked([]);
            }
          }}
        />
      </div>
    );
  } else {
    return <div className="pct-heading" style={{ width: width }}></div>;
  }
}

TextAndStatusFilter.propTypes = {
  cell: PropTypes.object,
  data: PropTypes.object,
  width: PropTypes.number,
};

function TextAndStatusFilter(props) {
  const { cell } = props;
  const { data } = props;
  const { width } = props;

  const [selectedItems, setSelectedItems] = useState([]);

  const statusTypes = getSelectList(cell.key, data);

  const handleSelectionChange = (newSelectedItems) => {
    setSelectedItems(newSelectedItems);
    updateMultipleFilters(cell.key, newSelectedItems, data, statusTypes);
  };

  return (
    <div className="pct-heading" style={{ width: width }}>
      {cell.isFiltered && (
        <MultiSelectDropdown
          options={statusTypes}
          selectedItems={selectedItems}
          onSelectionChange={handleSelectionChange}
          placeholder="Select options..."
        />
      )}
    </div>
  );
}

CurrencyAndQuantityFilter.propTypes = {
  cell: PropTypes.object,
  data: PropTypes.object,
  width: PropTypes.number,
};

function CurrencyAndQuantityFilter(props) {
  const { cell } = props;
  const { data } = props;
  const { width } = props;

  return (
    <div className="pct-heading" style={{ width: width }}>
      {cell.isFiltered && (
        <div>
          <input
            id="pct-filter-cell-currency-min"
            className="pct-filter-cell-min-max"
            placeholder="Min"
            onChange={(e) => {
              updateMinMaxFilters(cell.key, e.target.value, "min", data);
            }}
          />
          <input
            id="pct-filter-cell-currency-max"
            className="pct-filter-cell-min-max"
            placeholder="Max"
            onChange={(e) => {
              updateMinMaxFilters(cell.key, e.target.value, "max", data);
            }}
          />
        </div>
      )}
    </div>
  );
}

PercentFilter.propTypes = {
  cell: PropTypes.object,
  data: PropTypes.object,
  width: PropTypes.number,
};

function PercentFilter(props) {
  const { cell } = props;
  const { data } = props;
  const { width } = props;

  return (
    <div className="pct-heading-percent" style={{ width: width }}>
      {cell.isFiltered && (
        <div className="pct-min-max">
          <input
            id="pct-filter-cell-percent-min"
            className="pct-filter-cell-min-max"
            placeholder="Min"
            onChange={(e) => {
              updateMinMaxFilters(cell.key, e.target.value, "min", data);
            }}
          />
          <input
            id="pct-filter-cell-percent-max"
            className="pct-filter-cell-min-max"
            placeholder="Max"
            onChange={(e) => {
              updateMinMaxFilters(cell.key, e.target.value, "max", data);
            }}
          />
        </div>
      )}
    </div>
  );
}

DateFilter.propTypes = {
  cell: PropTypes.object,
  data: PropTypes.object,
  width: PropTypes.number,
};

function DateFilter(props) {
  const { cell } = props;
  const { data } = props;
  const { width } = props;

  return (
    <div className="pct-heading-percent" style={{ width: width }}>
      {cell.isFiltered && (
        <input
          id="pct-filter-cell-date"
          className="pct-filter-cell-description"
          placeholder="Search"
          onChange={(e) => {
            updateFilters(cell.key, e.target.value, data);
          }}
        />
      )}
    </div>
  );
}
